/* =================== SLIDE HOME =================== */
jQuery(document).ready(function ($) {
  // SLIDE
  $(".slide-home")
    .on("init", function () {
      $(".slide-content").show();
    })
    .slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 760,
          settings: {
            arrows: false,
            dots: true,
          },
        },
      ],
    })
    .on("beforeChange", function () {
      $(".slide-content").hide();
    })
    .on("afterChange", function () {
      $(".slide-content").show();
    });
  // Slide
});
